import axios from '@/libs/axios'

export default {
    namespaced: true,
    state: {
        baskets: [],
        selectedBasketitems: [],
        productBarcode: null,
        searchedFbaProducts: [],
        pagination: {},
        search: {
            basketName: '',
            storeId: 7,
            productBarcode: '',
            merchantSku: '',
            sellerSku: '',
            fnSku: '',
        },
    },
    getters: {
        _baskets(state) {
            return state.baskets
        },
        _selectedBasketitems(state) {
            return state.selectedBasketitems
        },
        _productBarcode(state) {
            return state.productBarcode
        },
        _searchedFbaProducts(state) {
            return state.searchedFbaProducts
        },
        _pagination(state) {
            return state.pagination
        },
        _search(state) {
            return state.search
        },
    },
    mutations: {
        setBaskets(state, baskets) {
            state.baskets = baskets
        },
        setSelectedBasketitems(state, selectedBasketitems) {
            state.selectedBasketitems = selectedBasketitems
        },
        addSelectedBasketitem(state, basketItemId) {
            if (!state.selectedBasketitems.includes(basketItemId)) {
                state.selectedBasketitems.push(basketItemId)
            }
        },
        addBasketItem(state, item) {
            state.baskets.unshift(item)
        },
        removeBasket(state, basketId) {
            const index = state.baskets.findIndex(basket => basket.id === basketId)
            if (index !== -1) {
                state.baskets.splice(index, 1)
            }
        },
        setBasket(state, { id, item }) {
            const index = state.baskets.findIndex(basket => basket.id === id)
            if (index !== -1) {
                state.baskets.splice(index, 1, item)
            }
        },
        setProductBarcode(state, productBarcode) {
            state.productBarcode = productBarcode
        },
        setSearchedFbaProducts(state, searchedFbaProducts) {
            state.searchedFbaProducts = searchedFbaProducts
        },
        setPagination(state, pagination) {
            state.pagination = pagination
        },
        setSearch(state, search) {
            state.search = {
                ...state.search,
                ...search,
            }
        },
        resetSearch(state) {
            state.search = {
                basketName: '',
                storeId: 7,
                productBarcode: '',
                merchantSku: '',
                sellerSku: '',
                fnSku: '',
            }
        },
    },
    actions: {
        getBaskets(context) {
            context.commit('setBaskets', [])
            return axios.get('/amazon/fba/product/basket', { params: { basket_name: context.state.search.basketName, store_id: context.state.search.storeId } })
                .then(response => {
                    context.commit('setBaskets', response.data.content)
                    return response.data
                })
                .catch(error => error)
        },
        addBasket(context, item) {
            return axios.post('/amazon/fba/product/basket', item)
                .then(response => {
                    context.commit('addBasketItem', response.data.content)
                    return response.data
                })
                .catch(error => error)
        },
        editBasket(context, { id, item }) {
            return axios.put(`/amazon/fba/product/basket/${id}`, item)
                .then(response => {
                    context.commit('setBasket', { id, item: response.data.content })
                    return response.data
                })
                .catch(error => error)
        },
        getFbaProducts(context, payload) {
            return axios.get('/amazon/fba/product', { params: payload })
                .then(response => {
                    context.commit('setSearchedFbaProducts', response.data.content)
                    return response.data.content
                })
        },
        getFbaProductsByBarcode(context, barcode) {
            // context.commit('setProductBarcode', barcode)
            return axios.get(`/amazon/fba/product/barcode/${barcode}`)
                .then(response => {
                    context.commit('setSearchedFbaProducts', response.data.content)
                    return response.data.content
                })
                .catch(error => error)
        },
        deleteBasket(context, id) {
            return axios.delete(`/amazon/fba/product/basket/${id}`)
                .then(response => {
                    context.commit('removeBasket', id)
                    return response.data
                })
                .catch(error => error)
        },
    },
}
